import type { ButtonProps } from '@lingoda/ui';
import { Button, muiFocusVisibleOutlineMixin } from '@lingoda/ui';
import { colorsPalette, styled } from '@lingoda/ui/theme';

export const StudentCreditsButton = ({ children, ...props }: ButtonProps) => {
    return (
        <CreditsButton
            disableRipple
            {...props}
            color="primary"
            variant="outlined"
            data-cy="expand-credits"
        >
            {children}
        </CreditsButton>
    );
};

const CreditsButton = styled(Button)(({ theme }) => ({
    borderColor: colorsPalette.blackAlpha[16],
    borderRadius: theme.spacing(3),
    padding: theme.spacing(1, 1.5),
    ...muiFocusVisibleOutlineMixin(theme, {
        marginLeft: theme.spacing(1),
    }),
    '&:hover': {
        borderColor: colorsPalette.blackAlpha[16],
        backgroundColor: colorsPalette.blackAlpha[4],
    },
    '&:active': {
        backgroundColor: colorsPalette.primaryAlpha[8],
        outline: 'none',
        boxShadow: 'none',
    },
}));
